export interface Status {
  name: Name;
  initials: InitialStatus;
  isSelected: boolean;
}

export enum Name {
  FILT = 'Filtrar por',
  ALL = 'Todas',
  PAI = 'Abonada',
  WTD = 'Denegada',
  TRF = 'Dev. Total',
  PRF = 'Dev. Parcial',
  NRF = 'Pte. Devolución',
  APP = 'Aprobada',
  CAP = 'Captura',
  NTP = 'Pte. Desembolso',
  EXP = 'Caducada',
  TUD = 'Rechazada',
  RTK = 'Retomada',
  EXT = 'Ampliada',
}

export enum InitialStatus {
  FiltrarTodas = 'FILTER',
  Todas = 'ALL',
  Abonada = 'PAI',
  Denegada = 'WTD',
  DevTotal = 'TRF',
  DevParcial = 'PRF',
  PteDevolucion = 'NRF',
  Aprobada = 'APP',
  Captura = 'CAP',
  PteDesembolso = 'NTP',
  Caducada = 'EXP',
  Rechazada = 'TUD',
  Retomada = 'RTK',
  Ampliada = 'EXT',
}

export enum FilterDashboard {
  MerchantId = 'merchant_id',
  DocumentId = '&document_id=',
  ClientName = '&client_name=',
  ProcessType = 'process_type',
  BussinessStatus = '&business_status=',
  CartId = '&cart_id=',
  ProposalReference = '&proposal_reference=',
  FromDate = '&from_date=',
  ToDate = '&to_date=',
  OrderBy = 'order_by',
  Sort = 'sort',
  CreditProposalId = 'credit_proposal_id',
}

export enum FilterTypes {
  nameOrDni = 'filterNameOrDni',
  cartId = 'filterCartID',
  calendar = 'filterCalendar',
}
